/* eslint-disable
    guard-for-in,
    no-restricted-syntax
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from 'react';

import * as CRISPRConstants from 'constants/CRISPRConstants';
import CRISPRDefaults, {CRISPRUserSettings} from 'molbio/crispr/CRISPRDefaults';

interface Props {
  disabled: boolean;
  initialShouldSetDefaults: boolean;
}

interface State {
  shouldSetDefaults: boolean;
}

export default class SetDefaultsInput extends React.Component<Props, State> {
  state: State = {
    shouldSetDefaults: this.props.initialShouldSetDefaults,
  };

  setDefaults = (settings: CRISPRUserSettings): void => {
    // showCutsOutsideRegions is a global preference, so it should always be set on save.
    CRISPRDefaults.set(CRISPRDefaults.KEYS.SHOW_CUTS_OUTSIDE_REGIONS, settings.showCutsOutsideRegions);
    if (this.state.shouldSetDefaults) {
      if (settings.pam === CRISPRConstants.AZIMUTH_SCORE_PAM) {
        // Only set the user's azimuth score preference if they're using the correct PAM for that score.
        CRISPRDefaults.set(
          CRISPRDefaults.KEYS.USE_AZIMUTH_ON_TARGET_SCORE,
          settings[CRISPRDefaults.KEYS.USE_AZIMUTH_ON_TARGET_SCORE]
        );
      }
      for (const key in settings) {
        const value = settings[key as keyof CRISPRUserSettings];
        if (key === CRISPRDefaults.KEYS.USE_AZIMUTH_ON_TARGET_SCORE) {
          continue;
        }
        CRISPRDefaults.set(key as keyof CRISPRUserSettings, value);
      }
    }
  };

  render(): JSX.Element {
    return (
      <div className="checkbox">
        <label>
          <input
            type="checkbox"
            checked={this.state.shouldSetDefaults}
            onChange={(e) => {
              this.setState({shouldSetDefaults: e.target.checked});
            }}
            disabled={this.props.disabled}
          />
          Save these as my default CRISPR settings
        </label>
      </div>
    );
  }
}
